import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Typography, Divider } from '@mui/material';
import DataTableWithForm from '../components/DataTableWithForm';
import MachineSelectDropdown from '../components/MachineSelectDropdown';
import VendingGrid from '../components/VendingGrid'; // new grid component

const ItemLocation = () => {
  const [selectedMachine, setSelectedMachine] = useState('');
  const [locationName, setLocationName] = useState('');
  const [layoutData, setLayoutData] = useState(null);

  // Fetch vending layout when machine is selected
  useEffect(() => {
    if (!selectedMachine) return;
    axios.get('https://app.zts-inc.com/zts/admin/v1.0/load/item/' + selectedMachine + '/')
      .then(res => setLayoutData(res.data))
      .catch(err => {
        console.error("Failed to fetch vending layout:", err);
        setLayoutData(null);
      });
  }, [selectedMachine]);

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h5" gutterBottom>Item Location</Typography>

      <MachineSelectDropdown
        selectedMachine={selectedMachine}
        setSelectedMachine={setSelectedMachine}
        setLocationName={setLocationName}
      />

      {selectedMachine ? (
        <>

          {layoutData ? (
            <VendingGrid layout={layoutData.layout} machine_uid={layoutData.machine_uid} max_col={layoutData.max_col}/>
          ) : (
            <Typography>Loading layout...</Typography>
          )}

          <Divider sx={{ my: 4 }} />

          {/* <DataTableWithForm
            title={'Manage Items for Machine: ' + selectedMachine}
            fetchUrl={'/zts/admin/v1.0/load/item/' + selectedMachine + '/'}
            createUrl="/zts/admin/v1.0/item/"
            updateUrl={(id) => '/zts/admin/v1.0/item/' + id + '/'}
            deleteUrl={(id) => '/zts/admin/v1.0/item/' + id + '/'}
            columns={[
              { field: 'item_name', label: 'Item' },
              { field: 'machine_serial', label: 'Machine' },
              { field: 'date_start', label: 'Date Start', format: (v) => v?.slice(0, 10) },
              { field: 'compartment', label: 'Compartment' },
              { field: 'max_quantity', label: 'Max Qty' },
              { field: 'balance_quantity', label: 'Balance' },
              { field: 'sales_price', label: 'Price' },
              { field: 'is_active', label: 'Active', format: (v) => v ? 'Yes' : 'No' },
            ]}
            formFields={[
              { name: 'item', label: 'Item' },
              { name: 'machine', label: 'Machine' },
              { name: 'date_start', label: 'Date Start', type: 'date' },
              { name: 'compartment', label: 'Compartment' },
              { name: 'max_quantity', label: 'Max Quantity' },
              { name: 'balance_quantity', label: 'Balance Quantity' },
              { name: 'sales_price', label: 'Sales Price' },
            ]}
          /> */}
        </>
      ) : (
        <Typography variant="body1" sx={{ mt: 4, color: 'text.secondary' }}>
          Please select a machine to view its item locations.
        </Typography>
      )}
    </Box>
  );
};

export default ItemLocation;


// import React, { useState } from 'react';
// import DataTableWithForm from '../components/DataTableWithForm';
// import MachineSelectDropdown from '../components/MachineSelectDropdown';
// import { Box, Typography } from '@mui/material';

// const ItemLocation = () => {
//   const [selectedMachine, setSelectedMachine] = useState('');
//   const [locationName, setLocationName] = useState('');

//   return (
//     <Box sx={{ p: 2 }}>
//       <Typography variant="h5" gutterBottom>Item Location</Typography>

//       <MachineSelectDropdown
//         selectedMachine={selectedMachine}
//         setSelectedMachine={setSelectedMachine}
//         setLocationName={setLocationName}
//       />

//       {selectedMachine ? (
//         <DataTableWithForm
//           title={`Items for Machine: ${selectedMachine}`}
//           fetchUrl={`/zts/admin/v1.0/item/?machine_uid=${selectedMachine}`}
//           createUrl="/zts/admin/v1.0/item/"
//           updateUrl={(id) => `/zts/admin/v1.0/item/${id}/`}
//           deleteUrl={(id) => `/zts/admin/v1.0/item/${id}/`}
//           columns={[
//             { field: 'item_name', label: 'Item' },
//             { field: 'machine_serial', label: 'Machine' },
//             { field: 'date_start', label: 'Date Start', format: (v) => v?.slice(0, 10) },
//             { field: 'compartment', label: 'Compartment' },
//             { field: 'max_quantity', label: 'Max Qty' },
//             { field: 'balance_quantity', label: 'Balance' },
//             { field: 'sales_price', label: 'Price' },
//             { field: 'is_active', label: 'Active', format: (v) => v ? 'Yes' : 'No' },
//           ]}
//           formFields={[
//             { name: 'item', label: 'Item' },
//             { name: 'machine', label: 'Machine' },
//             { name: 'date_start', label: 'Date Start', type: 'date' },
//             { name: 'compartment', label: 'Compartment' },
//             { name: 'max_quantity', label: 'Max Quantity' },
//             { name: 'balance_quantity', label: 'Balance Quantity' },
//             { name: 'sales_price', label: 'Sales Price' },
//           ]}
//         />
//       ) : (
//         <Typography variant="body1" sx={{ mt: 4, color: 'text.secondary' }}>
//           Please select a machine to view its item locations.
//         </Typography>
//       )}
//     </Box>
//   );
// };

// export default ItemLocation;



